import {
  IsNotEmpty,
  Max,
  Min,
  IsNumber,
  IsInt,
  IsPositive,
} from 'class-validator';

export class UserMealEntryModel {
  @IsNotEmpty({ message: 'MealTypeId is required' })
  @IsInt({ message: 'MealTypeId must be a whole number' })
  @Min(1, { message: 'Valid range for MealTypeId is 1-4' })
  @Max(4, { message: 'Valid range for MealTypeId is 1-4' })
  public mealTypeId: number;
  @IsNotEmpty({ message: 'A food selection must be provided' })
  @IsInt({ message: 'FoodId must be a whole number' })
  public foodId: number;
  @IsNotEmpty({ message: 'Quantity is required' })
  @IsNumber()
  @IsPositive({
    message: 'Quantity must be a positive number greater than zero',
  })
  @Max(2000, {
    message:
      'The quantity input for your food selection must be between 0.01 and 2000.',
  })
  public quantity: number;

  constructor(mealTypeId: number, foodId: number, quantity: number) {
    this.mealTypeId = mealTypeId;
    this.foodId = foodId;
    this.quantity = quantity;
  }
}
